const STAGES = [
  {
    tag: "Solar 1.0",
    title: "Residential Tax Credit Era",
    desc: "Homeowners purchased the system outright. A $30,000 system could produce approximately $9,000 in federal tax-credit value at a 30% rate. Tax benefits depend on individual eligibility and tax liability.",
    accent: "#D97706",
  },
  {
    tag: "Solar 2.0",
    title: "Commercial Tax Benefits + 1:1 Net Metering",
    desc: "The financing or system owner funds the installation and may receive applicable tax benefits. The homeowner buys the power — not the equipment.",
    accent: "#0F382C",
    present: true,
  },
  {
    tag: "Solar 3.0",
    title: "Reduced Net-Metering Credits",
    desc: "Utilities or regulators may reduce the value of exported-energy credits. Presented as a possible policy scenario — not a guaranteed future event.",
    accent: "#C2410C",
  },
  {
    tag: "Solar 4.0",
    title: "Limited or No Traditional Net Metering",
    desc: "Batteries may become more important if exported solar energy no longer receives favorable credits. No future regulatory change is guaranteed.",
    accent: "#164E3D",
  },
];

export default function SolarEvolution() {
  return (
    <section className="py-20 md:py-28 bg-[#FDFBF7]" data-testid="solar-evolution-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="eyebrow">The Evolution of Solar</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl font-semibold text-[#0F382C]">
            From tax-credit ownership to a predictable rate you simply purchase.
          </h2>
        </div>

        {/* Desktop horizontal timeline */}
        <div className="hidden lg:block mt-16 relative">
          <div className="absolute top-6 left-0 right-0 h-px bg-[#E5E0D8]" />
          <div className="grid grid-cols-4 gap-6 relative">
            {STAGES.map((s, i) => (
              <div key={s.tag} data-testid={`solar-evolution-stage-${i + 1}`} className="relative">
                <div className="flex items-center gap-3 mb-4">
                  <div
                    className={`w-3 h-3 rounded-full ring-4 ring-[#FDFBF7] ${s.present ? "animate-pulse" : ""}`}
                    style={{ background: s.present ? "#D97706" : s.accent, boxShadow: s.present ? "0 0 0 6px rgba(217,119,6,0.18)" : "none" }}
                  />
                  <div className="font-mono-metric text-xs tracking-widest" style={{ color: s.present ? "#B45309" : s.accent }}>
                    {s.tag}
                  </div>
                  {s.present && (
                    <span className="ml-auto text-[10px] font-mono-metric uppercase tracking-widest px-2 py-0.5 rounded-full bg-[#D97706] text-[#FDFBF7]">
                      You are here
                    </span>
                  )}
                </div>
                <div
                  className={`card-warm p-6 ${s.present ? "ring-2 ring-[#D97706] shadow-[0_20px_40px_-12px_rgba(217,119,6,0.35)]" : ""}`}
                  style={s.present ? { background: "linear-gradient(180deg, #FFFDF6 0%, #FEF3C7 100%)" } : {}}
                >
                  {s.present && (
                    <div className="eyebrow mb-2" data-testid="solar-evolution-present-label">Present Era</div>
                  )}
                  <h3 className="font-serif-display text-xl text-[#0F382C] leading-snug">{s.title}</h3>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile stacked timeline */}
        <div className="lg:hidden mt-12 space-y-5">
          {STAGES.map((s, i) => (
            <div
              key={s.tag}
              className={`card-warm p-6 relative ${s.present ? "ring-2 ring-[#D97706]" : ""}`}
              style={s.present ? { background: "linear-gradient(180deg, #FFFDF6 0%, #FEF3C7 100%)" } : {}}
              data-testid={`solar-evolution-stage-mobile-${i + 1}`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-2.5 h-2.5 rounded-full ${s.present ? "animate-pulse" : ""}`} style={{ background: s.present ? "#D97706" : s.accent }} />
                <div className="font-mono-metric text-xs tracking-widest" style={{ color: s.present ? "#B45309" : s.accent }}>
                  {s.tag}
                </div>
                {s.present && (
                  <span className="ml-auto text-[10px] font-mono-metric uppercase tracking-widest px-2 py-0.5 rounded-full bg-[#D97706] text-[#FDFBF7]">
                    You are here
                  </span>
                )}
              </div>
              {s.present && (
                <div className="eyebrow mb-2">Present Era</div>
              )}
              <h3 className="font-serif-display text-xl text-[#0F382C]">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
